import { Toaster } from "react-hot-toast";
import { ThemeProvider, Box } from "@mui/material";
import { theme } from "create-theme";
import routes from "routes/index";
import "./App.css";

function App() {
  return (
    <Box>
      <GlobalToaster />
      <Box sx={{ width: "100%", overflowY: 'hidden' }}>
        <ThemeProvider theme={theme}>
          {routes()}
        </ThemeProvider>
      </Box>
    </Box>
  );
}

const GlobalToaster = () => {
  return (
    <Toaster
      containerStyle={{
        top: 110,
      }}
      position="top-center"
      reverseOrder={false}
    />
  );
};

export default App;
